import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent} from './about/about.component';
import { RolodexComponent } from './icms/rolodex/rolodex.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { CurrentUserComponent} from './current-user/current-user.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full'},
  { path: 'home', component: RolodexComponent },
  { path: 'about', component: AboutComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'currentUser', component: CurrentUserComponent },
  { path: '**', component: RolodexComponent }  // path not found
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
